"use strict";
/*
 * To change this template, choose Tools | Templates
 * and open the template in the editor.
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.TextInfo = void 0;
/**
 *
 *
 */
class TextInfo {
    _ModifierString;
    _ModifierStringPosition;
    _ModifierStringAngle = 0;
    constructor() { }
    //set this when returning text string.
    setModifierString(value) {
        this._ModifierString = value;
    }
    getModifierString() {
        return this._ModifierString;
    }
    //location to draw ModifierString.
    setModifierStringPosition(value) {
        this._ModifierStringPosition = value;
    }
    getModifierStringPosition() {
        return this._ModifierStringPosition;
    }
    //angle to draw ModifierString.
    setModifierStringAngle(value) {
        this._ModifierStringAngle = value;
    }
    getModifierStringAngle() {
        return this._ModifierStringAngle;
    }
}
exports.TextInfo = TextInfo;
//# sourceMappingURL=TextInfo.js.map